module.exports = __webpack_public_path__ + "img/definir_servicos.a5e6d22e.svg";